export const summaryRows: string[] = [
  "Volume 1 — Fondamenti dell'Industria Mineraria e delle Risorse Minerali",
  'Volume 2 — Geologia, Minerali e Giacimenti Minerari',
  'Volume 3 — Esplorazione Mineraria e Valutazione delle Risorse',
  'Volume 4 — Metodi di Estrazione a Cielo Aperto e in Sotterraneo',
  'Volume 5 — Trattamento dei Minerali e Recupero del Valore',
  'Volume 6 — Sicurezza, Ambiente e Chiusura delle Miniere',
  'Bonus 1 — 150 Attività su Industria Mineraria e Risorse Minerali per la Classe',
  'Bonus 2 — Raccolta di Verifiche su Industria Mineraria e Risorse Minerali',
  "Bonus 3 — 100 Casi di Studio e Scenari Reali dell'Industria Mineraria",
  'Bonus 4 — 50 Progetti e Sfide di Indagine su Miniere e Risorse Minerali',
  "Bonus 5 — Guida del Docente a Concetti e Terminologia dell'Industria Mineraria",
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
